import React from 'react'

function Udashboard() {
  return (
    <div className="absolute lg:left-[300px] max-w-[1026px] top-12 h-auto container my-12 mx-auto px-4 md:px-12">
        <div class="container my-12 mx-auto px-4 md:px-12">
            <div class="flex flex-wrap -mx-1 lg:-mx-4">
                <div class="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">
                    <div class="overflow-hidden rounded-lg shadow-lg">
                        <a href="#err">
                            <img alt="Placeholder" class="block h-auto w-full" src="https://media.istockphoto.com/id/1086329452/photo/empty-parking-lot.jpg?s=612x612&w=0&k=20&c=EjuUn0YTgv2nVRWIeyLvO_yQQwJOr877cQl9E87FjKc="/>
                        </a>
                        <div class="flex items-center justify-between leading-tight p-2 md:p-4">
                            <h1 class="text-lg">
                                <a class="no-underline hover:underline text-black" href="#err">
                                    Parking Area In Bangalore
                                </a>
                            </h1>
                            <p class="text-grey-darker text-sm">
                                11/1/19
                            </p>
                        </div>
                        <div className="flex items-center justify-start">
                        <small className=' py-1 text-justify'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur molestiae nulla expedita corporis error labore sunt ullam repellendus quibusdam mollitia.
                        </small>
                        </div>
                        <div class="flex items-center justify-between leading-none p-2 md:p-4">
                            <a class="flex items-center no-underline hover:underline text-black" href="#err">
                                <img alt="Placeholder" class="block rounded-full" src="https://picsum.photos/32/32/?random"/>
                                <p class="ml-2 text-sm">
                                    Owner  1
                                </p>
                            </a>
                            <a class="no-underline text-grey-darker hover:text-red-dark" href="#err">
                                
                                <i class="fa-solid fa-share-nodes"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">  
                    <div class="overflow-hidden rounded-lg shadow-lg">
                        <a href="#err">
                            <img alt="Placeholder" class="block h-auto w-full" src="https://media.istockphoto.com/id/1086329452/photo/empty-parking-lot.jpg?s=612x612&w=0&k=20&c=EjuUn0YTgv2nVRWIeyLvO_yQQwJOr877cQl9E87FjKc="/>
                        </a>
                        <div class="flex items-center justify-between leading-tight p-2 md:p-4">
                            <h1 class="text-lg">
                                <a class="no-underline hover:underline text-black" href="#err">
                                    Parking Area In Bangalore
                                </a>
                            </h1>
                            <p class="text-grey-darker text-sm">
                                11/1/19
                            </p>
                        </div>
                        <div className="flex items-center justify-start">
                        <small className=' py-1 text-justify'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur molestiae nulla expedita corporis error labore sunt ullam repellendus quibusdam mollitia.
                        </small>
                        </div>
                        <div class="flex items-center justify-between leading-none p-2 md:p-4">
                            <a class="flex items-center no-underline hover:underline text-black" href="#err">
                                <img alt="Placeholder" class="block rounded-full" src="https://picsum.photos/32/32/?random"/>
                                <p class="ml-2 text-sm">
                                    Owner  2
                                </p>
                            </a>
                            <a class="no-underline text-grey-darker hover:text-red-dark" href="#err">
                                
                                <i class="fa-solid fa-share-nodes"></i>
                            </a>
                        </div>
                    </div>
                </div>   
                <div class="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">  
                    <div class="overflow-hidden rounded-lg shadow-lg">
                        <a href="#err">
                            <img alt="Placeholder" class="block h-auto w-full" src="https://media.istockphoto.com/id/1086329452/photo/empty-parking-lot.jpg?s=612x612&w=0&k=20&c=EjuUn0YTgv2nVRWIeyLvO_yQQwJOr877cQl9E87FjKc="/>
                        </a>
                        <div class="flex items-center justify-between leading-tight p-2 md:p-4">
                            <h1 class="text-lg">
                                <a class="no-underline hover:underline text-black" href="#err">
                                    Parking Area In Bangalore
                                </a>
                            </h1>
                            <p class="text-grey-darker text-sm">
                                11/1/19
                            </p>
                        </div>
                        <div className="flex items-center justify-start">
                        <small className=' py-1 text-justify'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur molestiae nulla expedita corporis error labore sunt ullam repellendus quibusdam mollitia.
                        </small>
                        </div>
                        <div class="flex items-center justify-between leading-none p-2 md:p-4">
                            <a class="flex items-center no-underline hover:underline text-black" href="#err">
                                <img alt="Placeholder" class="block rounded-full" src="https://picsum.photos/32/32/?random"/>
                                <p class="ml-2 text-sm">
                                    Owner  3
                                </p>
                            </a>
                            <a class="no-underline text-grey-darker hover:text-red-dark" href="#err">        
                                <i class="fa-solid fa-share-nodes"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">    
                    <div class="overflow-hidden rounded-lg shadow-lg">
                        <a href="#err">
                            <img alt="Placeholder" class="block h-auto w-full" src="https://media.istockphoto.com/id/1086329452/photo/empty-parking-lot.jpg?s=612x612&w=0&k=20&c=EjuUn0YTgv2nVRWIeyLvO_yQQwJOr877cQl9E87FjKc="/>
                        </a>
                        <div class="flex items-center justify-between leading-tight p-2 md:p-4">
                            <h1 class="text-lg">
                                <a class="no-underline hover:underline text-black" href="#err">
                                    Parking Area In Bangalore
                                </a>
                            </h1>
                            <p class="text-grey-darker text-sm">
                                11/1/19
                            </p>
                        </div>
                        <div className="flex items-center justify-start">
                        <small className=' py-1 text-justify'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur molestiae nulla expedita corporis error labore sunt ullam repellendus quibusdam mollitia.
                        </small>
                        </div>
                        <div class="flex items-center justify-between leading-none p-2 md:p-4">
                            <a class="flex items-center no-underline hover:underline text-black" href="#err">
                                <img alt="Placeholder" class="block rounded-full" src="https://picsum.photos/32/32/?random"/>
                                <p class="ml-2 text-sm">
                                    Owner  4
                                </p>
                            </a>
                            <a class="no-underline text-grey-darker hover:text-red-dark" href="#err">                 
                            <i class="fa-solid fa-share-nodes"></i>
                            </a>
                        </div>
                    </div>
                </div>     
                <div class="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">           
                    <div class="overflow-hidden rounded-lg shadow-lg">
                        <a href="#err">
                            <img alt="Placeholder" class="block h-auto w-full" src="https://media.istockphoto.com/id/1086329452/photo/empty-parking-lot.jpg?s=612x612&w=0&k=20&c=EjuUn0YTgv2nVRWIeyLvO_yQQwJOr877cQl9E87FjKc="/>
                        </a>
                        <div class="flex items-center justify-between leading-tight p-2 md:p-4">
                            <h1 class="text-lg">
                                <a class="no-underline hover:underline text-black" href="#err">
                                    Parking Area In Bangalore
                                </a>
                            </h1>
                            <p class="text-grey-darker text-sm">
                                11/1/19
                            </p>
                        </div>
                        <div className="flex items-center justify-start">
                        <small className=' py-1 text-justify'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur molestiae nulla expedita corporis error labore sunt ullam repellendus quibusdam mollitia.
                        </small>
                        </div>
                        <div class="flex items-center justify-between leading-none p-2 md:p-4">
                            <a class="flex items-center no-underline hover:underline text-black" href="#err">
                                <img alt="Placeholder" class="block rounded-full" src="https://picsum.photos/32/32/?random"/>
                                <p class="ml-2 text-sm">
                                    Owner  5
                                </p>
                            </a>
                            <a class="no-underline text-grey-darker hover:text-red-dark" href="#err">                         
                                <i class="fa-solid fa-share-nodes"></i>
                            </a>
                        </div>
                    </div>
                </div>
            
                <div class="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">          
                    <div class="overflow-hidden rounded-lg shadow-lg">
                        <a href="#err">
                            <img alt="Placeholder" class="block h-auto w-full" src="https://media.istockphoto.com/id/1086329452/photo/empty-parking-lot.jpg?s=612x612&w=0&k=20&c=EjuUn0YTgv2nVRWIeyLvO_yQQwJOr877cQl9E87FjKc="/>
                        </a>
                        <div class="flex items-center justify-between leading-tight p-2 md:p-4">
                            <h1 class="text-lg">
                                <a class="no-underline hover:underline text-black" href="#err">
                                    Parking Area In Bangalore
                                </a>
                            </h1>
                            <p class="text-grey-darker text-sm">
                                11/1/19
                            </p>
                        </div>
                        <div className="flex items-center justify-start">
                        <small className=' py-1 text-justify'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur molestiae nulla expedita corporis error labore sunt ullam repellendus quibusdam mollitia.
                        </small>
                        </div>
                        <div class="flex items-center justify-between leading-none p-2 md:p-4">
                            <a class="flex items-center no-underline hover:underline text-black" href="#err">
                                <img alt="Placeholder" class="block rounded-full" src="https://picsum.photos/32/32/?random"/>
                                <p class="ml-2 text-sm">
                                    Owner  6
                                </p>
                            </a>
                            <a class="no-underline text-grey-darker hover:text-red-dark" href="#err">       
                                <i class="fa-solid fa-share-nodes"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Udashboard